/**
 * Testimonial JS
 * -----------------------------------------------------------------------------
 *
 * All the JS for the Testimonial component.
 */

import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    className: 'testimonial',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( document ).ready( function() {
        if ( $( '.testimonial-slider__splide' ).length ) {
          $( '.testimonial-slider__splide' ).each( function( index, element ) {
            const splideInstance = new Splide( element, {
              type: 'loop',
              gap: '32px',
              perMove: 1,
              drag: false,
              arrows: true,
              pagination: false,
              speed: 800,
              breakpoints: {
                768: {
                  perPage: 1,
                },
                1024: {
                  perPage: 3,
                },
              },
              perPage: 3,
            } );

            splideInstance.mount();
          } );
        }
      } );
    },
    finalize: function() {},
  };

  app.registerComponent( 'testimonial', COMPONENT );
} )( app );
